






















import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
    components: {},
})
export default class BaseContainer extends Vue {
    @Prop({
        default: '',
    })
    public title: string;

    public created() {}
    public mounted() {}
}
